import React from 'react';
import { BalanceDetails } from '../CheckBalance/BalanceDetails';
import { UnitDetails } from '../CheckBalance/UnitDetails';
import { Columns } from '@codeparva/ui-components-library';
import { TransactionsDetails } from '../CheckBalance/TransactionsDetails';
import { CheckBalanceTypes } from '../../CheckBalanceTypes';
import { payment_page_url } from '../../constants/accountPanelConfigs';

export const CheckBalance = ({
  tenantData,
  ledgerId,
  ledgerTransactionInfo,
  unitDataAndRelationalData,
}: CheckBalanceTypes.TCheckBalanceDetails) => {
  const { ledger: ledgerList = [] } = tenantData;
  const selectedLedgerInfo = ledgerList.filter(
    eachLedger => eachLedger.id === ledgerId
  );
  const {
    last_paid: {
      date: last_payment_date = '',
      amount: last_payment_amount = 0,
    } = {
      date: '',
      amount: 0,
    },
    balance: ledger_balance = 0,
  } = selectedLedgerInfo[0] ?? {
    last_paid: {},
    balance: '',
  };
  const balanceComponentObj = {
    last_payment_date,
    last_payment_amount,
    ledger_balance,
    payment_page_url,
  };
  return (
    <div className="checkBalanceContainer">
      <Columns multiline={false} className="balanceAndUnitDetails">
        <BalanceDetails {...balanceComponentObj} />
      </Columns>
      <TransactionsDetails ledgerTransactionInfo={ledgerTransactionInfo} />
      <UnitDetails {...unitDataAndRelationalData} />
    </div>
  );
};
